export default "__VITE_ASSET__OetwawOY__"